import { gql } from '@apollo/client';

export interface TriggerReindexResponse {
  triggerReindex: {
    success: boolean;
    message: string;
  };
}

/**
 * Phase of the blue/green swap as reported by the Go reindexer. Null for
 * legacy upsert runs and for the initial startup window before any phase
 * has been written to the progress file.
 */
export type SwapPhase =
  | 'preflight'
  | 'creating_index'
  | 'reindexing'
  | 'verifying'
  | 'swapping'
  | 'cleanup'
  | 'done'
  | 'error';

export interface ReindexStatusData {
  status: 'idle' | 'running' | 'done' | 'error';
  phase: SwapPhase | null;
  total: number;
  completed: number;
  error: string | null;
}

export interface ReindexStatusResponse {
  reindexStatus: ReindexStatusData;
}

export const TRIGGER_REINDEX = gql`
  mutation TriggerReindex {
    triggerReindex {
      success
      message
    }
  }
`;

export const REINDEX_STATUS = gql`
  query ReindexStatus {
    reindexStatus {
      status
      phase
      total
      completed
      error
    }
  }
`;

/** Human label for a Go swap phase. Used by status UIs. */
export function swapPhaseLabel(phase: SwapPhase | null): string | null {
  switch (phase) {
    case 'preflight':
      return 'Checking transcripts';
    case 'creating_index':
      return 'Creating new index';
    case 'reindexing':
      return 'Reindexing';
    case 'verifying':
      return 'Verifying';
    case 'swapping':
      return 'Swapping alias';
    case 'cleanup':
      return 'Cleaning up old index';
    case 'done':
      return 'Done';
    case 'error':
      return 'Failed';
    default:
      return null;
  }
}
